module.exports = __webpack_public_path__ + "img/ewm2.3b73dd4f.jpg";